import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from '@/components/shadcn/ui/menubar';
import { getTokenFromStorage } from '@/utils/getToken';

export interface TokenPayload {
  sub: number;
  username: string;
  companyId: number;
  company: string;
  roles: string[];
  colaboratorId: number | null;
  iat?: number;
  exp?: number;
}

function MenuTabs() {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  useEffect(() => {
    const fetchTokenData = async () => {
      let token = getTokenFromStorage();
      let decodedToken: TokenPayload | undefined;
      if (token) {
        try {
          decodedToken = jwtDecode<TokenPayload>(token);       
          if (decodedToken.roles.includes('admin')) {
            setIsAdmin(true);
          }
        } catch (error) {
          console.error("Erro ao decodificar token:", error);
        }
      }
      if (!decodedToken) {
        setTimeout(() => {
          token = getTokenFromStorage();
          if (token) {
            try {
              decodedToken = jwtDecode<TokenPayload>(token);

              if (decodedToken.roles.includes('admin')) {
                setIsAdmin(true);
              }
            } catch (error) {
              console.error("Erro ao tentar decodificar token novamente:", error);
            }
          }
        }, 3000); 
      }
    };

    fetchTokenData();
  }, []);

  return (
    <div>
      <Menubar>
        <MenubarMenu>
          <Link to='/'>
            <MenubarTrigger>Dashboard</MenubarTrigger>
          </Link>
        </MenubarMenu>

        <MenubarMenu>
          <Link to='/kanban'>
            <MenubarTrigger>Kanban</MenubarTrigger>
          </Link>
        </MenubarMenu>

        {isAdmin && (
          <MenubarMenu>
            <Link to='/colaboradores'>
              <MenubarTrigger>Colaboradores</MenubarTrigger>
            </Link>
          </MenubarMenu>
        )}

        <MenubarMenu>
          <MenubarTrigger>Configurações</MenubarTrigger>
          <MenubarContent>
            {isAdmin && (
              <>
                <Link to='/fluxo'>
                  <MenubarItem>Fluxo de Oportunidade</MenubarItem>
                </Link>
                <MenubarSeparator />
              </>
            )}
            <Link to='/settingEmail'>
              <MenubarItem>Configurar Email</MenubarItem>
            </Link>
            <Link to='/templateEmail'>
              <MenubarItem>Template Assunto do Email</MenubarItem>
            </Link>
            {isAdmin && (
              <>
                <MenubarSeparator />
                <Link to='/tipoatividade'>
                  <MenubarItem>Tipos de Atividade</MenubarItem>
                </Link>
                <Link to='/ramoatividade'>
                  <MenubarItem>Ramo de Atividade</MenubarItem>
                </Link>
              </>
            )}
            <MenubarSeparator />
            <Link to='/fonte'>
              <MenubarItem>Fonte</MenubarItem>
            </Link>
          </MenubarContent>
        </MenubarMenu>

        {isAdmin && (
          <MenubarMenu>
            <MenubarTrigger>Cadastro</MenubarTrigger>
            <MenubarContent>
              <Link to='/produtos'>
                <MenubarItem>Produtos</MenubarItem>
              </Link>
              <Link to='/clientes'>
                <MenubarItem>Clientes</MenubarItem>
              </Link>
              <Link to='/users'>
                <MenubarItem>Usuarios</MenubarItem>
              </Link>
              <Link to='/indicadores'>
                <MenubarItem>Indicadores</MenubarItem>
              </Link>
              <Link to='/sellers'>
                <MenubarItem>Vendedores</MenubarItem>
              </Link>
            </MenubarContent>
          </MenubarMenu>
        )}
      </Menubar>
    </div>
  );
}

export default MenuTabs;
